<template>
  <div class="card p-5">
    <div class="row title">
      <div class="col p-0">
        <div class="h3 m-0">{{ $t('surveyProgress.title') }}</div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col p-0">
        <h6 class="ml-auto mr-auto text-right">
          {{ progressBar.completed + ' ' + $t('surveyProgress.counter1') + ' ' +
            progressBar.total + ' ' + this.getSurveyProgressText() }}
        </h6>
      </div>
    </div>
    <AppProgress
      :completed="progressBar.completed"
      :in-progress="progressBar.inProgress"
      :in-revision="progressBar.inRevision"
      :returned="progressBar.returned"
      :total="progressBar.total"
      :has-workflow="hasWorkflow"
    />
  </div>
</template>

<script>
import store from "../../store/store";
import AppProgress from "@/components/SharedComponents/AppProgress.vue";

export default {
  'name': 'SurveyProgress',
  components: { AppProgress },
  'props': {
    'progressBar': {},
    'hasWorkflow': false,
  },
  'methods': {
    getSurveyProgressText() {
      let textResponse = ''
      let filteredRoles = store.state.loggedUser?.roles?.filter((rol) => rol.role === 'SUPERVISOR') ?? []

      if(filteredRoles.length > 0) {
        textResponse = this.$t('surveyProgress.supervisor.counter2')
      } else {
        textResponse = this.$t('surveyProgress.counter2')
      }

      return textResponse
    }
  }
}
</script>

<style scoped>
  .title {
    margin: 0 0 20px ;
  }
</style>
